import api from '../../api'

const HEALTH_CHECK_INTERVAL = 30000

export default {
    name: 'connection',
    actions: {
        async initialize({ dispatch }) {
            await dispatch('checkConnectionToCrm')
            setInterval(function () {
                dispatch('checkConnectionToCrm')
            }, HEALTH_CHECK_INTERVAL)
        },
        async checkConnectionToCrm({ commit }) {
            var data = await api.connection.check()
            commit('SET_SERVER_STATE', data)
        }
    },
    state: {
        isServerAvailable: true
    },
    mutations: {
        SET_SERVER_STATE(state, isAvailable) {
            state.isServerAvailable = isAvailable
        }
    },
    getters: {
        isServerAvailable(state) {
            return state.isServerAvailable
        }
    }
}
